import CheckIcon from "@mui/icons-material/CheckOutlined";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react-lite";

export default observer(function ProposalSigneeChip({ name, hasSigned }: { name: string, hasSigned?: boolean }) {
   const signedColour = '#388061'

   return (
      <Chip variant="outlined" sx={{
         minHeight: '30px',
         height: 'auto',
         ...(hasSigned ? {
            borderColor: signedColour,
            color: signedColour,
         } : {}),
         '> span': {
            paddingX: 1,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: .5,
         },
      }} label={<>
         {hasSigned && <CheckIcon />}
         <Typography>{name}</Typography>
      </>} />
   );
})